import {
  computed,
  ref,
  toRef,
} from "vue";

import PuxTablePlugin, {
  tablePluginOptions,
} from "../plugin/PuxTablePlugin";

import {
  setUrlWithParams
} from "aloha-vue/src/compositionAPI/AHttpAPI.js";
import {
  cloneDeep,
  forEach,
  keyBy,
} from "lodash-es";

export default function ActionsAPI(props, {
  modelColumnsOrderingLocal = ref([]),
  modelColumnsVisible = ref({}),
  modelFilters = ref({}),
  modelSortLocal = ref(""),
  urlParametersLocal = computed(() => ({})),
}) {
  const columns = toRef(props, "columns");
  const csvExport = toRef(props, "csvExport");
  const id = toRef(props, "id");
  const tableActions = toRef(props, "tableActions");
  const url = toRef(props, "url");
  const urlParams = toRef(props, "urlParams");

  const {
    checkPermissionsSync,
  } = PuxTablePlugin.PermissionAPI();

  const {
    closeModalCsvExport,
    isCsvExportModalVisible,
    openModalCsvExport,
    selectorCloseCsvExport,
  } = PuxTablePlugin.CsvExportModalAPI();

  const columnsKeyById = computed(() => {
    return keyBy(columns.value, "id");
  });

  const urlCsvExport = computed(() => {
    if (csvExport.value === "async") {
      return `${ url.value }csv_async/`;
    } else if (csvExport.value === "sync") {
      return `/api/${ url.value }csv/`;
    }
    return "";
  });

  const fields = computed(() => {
    const FIELDS = [];

    forEach(modelColumnsOrderingLocal.value, columnId => {
      if (modelColumnsVisible.value[columnId] !== false && columnsKeyById.value[columnId]) {
        if (columnsKeyById.value[columnId].idCsv) {
          FIELDS.push(columnsKeyById.value[columnId].idCsv);
        } else if (columnsKeyById.value[columnId].keyLabel) {
          FIELDS.push(columnsKeyById.value[columnId].keyLabel.split(".")[0]);
        }
      }
    });

    return FIELDS;
  });

  const urlParamsCsvExport = computed(() => {
    const URL_PARAMS = {
      ...urlParams.value,
      ...modelFilters.value,
      ordering: modelSortLocal.value,
      fields: fields.value,
    };

    return URL_PARAMS;
  });


  const tableActionsFiltered = computed(() => {
    const ACTIONS = [];
    forEach(cloneDeep(tableActions.value), action => {
      if (!action.permission ||
        checkPermissionsSync({ perm: action.permission })) {
        action.permission = undefined;
        if (action.type === "button") {
          const CALLBACK_DEFAULT = action.callback;
          action.callback = arg => CALLBACK_DEFAULT({
            ...arg,
            urlParams: urlParametersLocal.value,
          });
        } else if (action.type === "link") {
          if (action.hrefCallback) {
            action.href = action.hrefCallback({
              urlParams: urlParametersLocal.value,
              urlParamsString: setUrlWithParams({ url: "", params: urlParametersLocal.value }),
            });
          }
        }
        if (action.class) {
          action.classButton = action.class;
          delete action.class;
        }

        ACTIONS.push(action);
      }
    });

    if (tablePluginOptions.value.global.project === "pvp") {
      if (csvExport.value === "async") {
        ACTIONS.push({
          type: "divider",
        });
        ACTIONS.push({
          iconLeft: "FiletypeCsv",
          type: "button",
          callback: openModalCsvExport,
          class: "a_btn a_btn_secondary",
          title: "Liste exportieren",
          textScreenReader: "Liste exportieren",
          id: `${ id.value }_csv`,
        });
      } else if (csvExport.value === "sync") {
        ACTIONS.push({
          type: "divider",
        });
        ACTIONS.push({
          iconLeft: "FiletypeCsv",
          type: "link",
          href: setUrlWithParams({
            url: urlCsvExport.value,
            params: urlParamsCsvExport.value,
          }),
          class: "a_btn a_btn_secondary",
          title: "Liste exportieren",
          textScreenReader: "Liste exportieren",
          id: `${ id.value }_csv`,
          target: "_self",
        });
      }
    }

    return ACTIONS;
  });


  return {
    closeModalCsvExport,
    isCsvExportModalVisible,
    selectorCloseCsvExport,
    tableActionsFiltered,
    urlCsvExport,
    urlParamsCsvExport,
  };
}
